import { SnowEffectComponent } from './snow-effect/snow-effect.component';
export const effectComponents: any[] = [SnowEffectComponent];
